import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserInterface } from '../../common/types/types'
import { RootState } from '../store'

const initialState: { user: UserInterface | undefined } = {
  user: undefined,
}

export const currentUserSlice = createSlice({
  name: 'current-user',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<UserInterface | undefined>) => {
      // Исправляем: не делаем spread для undefined
      state.user = action.payload ? { ...action.payload } : undefined
    },
    resetCurrentUser: (state) => {
      state.user = undefined
    },
  },
})

export const { setCurrentUser, resetCurrentUser } = currentUserSlice.actions

export const selectCurrentUser = (state: RootState) => state.currentUser.user

export default currentUserSlice.reducer
